<template>
  <section>
    <nav aria-label="breadcrumb">
        <ol class="breadcrumb">
            <li
              v-for="(route, index) in breadcrumbsData"
              class="breadcrumb-item"
              :key="index"
              :class="{ active: route.selected }"
            >
               <a v-if="!route.selected" v-on:click="onClick(route)">{{route.title}}</a>
               {{route.selected ? route.title : null}}
            </li>
        </ol>
    </nav>
  </section>
</template>

<script>
export default {
  name: 'Breadcrumb',
  props: {
    breadcrumbsData: {
      type: Array,
      required: true,
      default: [],
    },
  },
  methods: {
    onClick(item) {
      const goto = this.getGoto(item);
      this.$router.push(goto);
    },
    getClass(item) {
      return item && item.selected ? 'active' : '';
    },
    getGoto(item) {
      const obj = Object.assign({}, item);
      return Object.assign({}, obj.goto);
    },
  },
};
</script>
<style scoped>
.breadcrumb {
  background: white;
  margin-bottom: 0%;
}

.breadcrumb-item a {
  color: #00788D;
  cursor: pointer;
}

.breadcrumb-item.active {
  color: #909FA7;
}

.breadcrumb-item+.breadcrumb-item::before {
  display: inline-block;
  padding-right: .5rem;
  content: "›";
}
</style>



// WEBPACK FOOTER //
// Breadcrumb.vue?2aa0f288